import Block from './Block'

export default class IntroBlock extends Block {
    
    constructor(contentRoot) {
        super(contentRoot)
        
        const video = contentRoot.find('.introBlock-video')
        if (video) {
            const iframe = video.find('iframe'),
                  hdRatio = 16/9
            
            let ratio = contentRoot.width() / contentRoot.height()
            
            const resizeListener = function() {
                ratio = contentRoot.width() / contentRoot.height()
                if (ratio < hdRatio) {
                    iframe.css({
                        left: '50%',
                        transform: `translate(-50%, -50%) scale(${1 + (hdRatio - ratio) * (window.innerHeight / window.innerWidth)})`,
                    })
                } else {
                    iframe.css({
                        left: '50%',
                        transform: `translate(-50%, -50%)`,
                    })
                }
            }
            $(window).on('resize orientationchange load', resizeListener)
        }
    }
}

